

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const roleManager = namespace("roleManager");
const userManager = namespace("userManager");
import { filterNodeData } from "@root/lib/utils";
@Component({})
export default class role extends Vue {
  @Prop()
  editData: any;
  dialogVisible: boolean = false;
  loading: boolean = false;
  checkList: any = [];
  roleList: any = [];
  @roleManager.Action getRoleList;
  @userManager.Action bindUserRoles;
  @Watch("editData")
  onEditDataChange(val) {
    let { roleList = [] } = val;
    this.checkList = roleList.map(i => i.roleCode);
  }
  async mounted() {
    let { dataList } = await this.getRoleList({
      pageInput: {
        pageSize: 1000,
        pageNum: 1
      }
    });
    this.roleList = filterNodeData(dataList);
  }
  async handleSubmit() {
    this.loading = true;
    await this.bindUserRoles({
      userCode: this.editData.userCode,
      roleCodeList: this.checkList
    })
      .then(_ => {
        this.$emit("refresh", 1);
        this.$message.success("绑定成功");
        this.dialogVisible = false;
      })
      .finally(_ => {
        this.loading = false;
      });
  }
}
